export default __webpack_public_path__ + "static/media/spinner.fa8b8581.gif";